module.exports = __webpack_public_path__ + "static/media/dxc.0b77d211.svg";